import { PasswordTextInput } from '../../comps/PasswordTextInput/PasswordTextInput'
import { forgotPwdStrings } from '../../data/static/strings'
import { testProps } from '../../util/util'
import { setPassword } from '../../util/validations'
import { CheckList } from './CheckList'

export const resetForm = (): any => {
  return [
    {
      formItems: [
        {
          fieldName: 'password',
          ComponentName: PasswordTextInput,
          label: forgotPwdStrings.setNewPassword,
          validationSchema: setPassword,
          ...testProps('pwd-input'),
          autoFocus: false,
        },
        {
          fieldName: 'checklist',
          ComponentName: CheckList,
        },
        {
          fieldName: 'passwordConfirm',
          ComponentName: PasswordTextInput,
          ...testProps('confm-pwd-input'),
          label: forgotPwdStrings.confirmPassword,
          validationSchema: setPassword,
          returnKeyType: 'done',
        },
      ],
    },
  ]
}

export const pwdStrengthCbData = [
  {
    id: '1',
    value: forgotPwdStrings.eightCharacters,
  },
  {
    id: '2',
    value: forgotPwdStrings.oneLowerCaseLetter,
  },
  {
    id: '3',
    value: forgotPwdStrings.oneCapitalLetter,
  },
  {
    id: '4',
    value: forgotPwdStrings.oneSpecialCharacter,
  },
  {
    id: '5',
    value: forgotPwdStrings.oneDigit,
  },
  {
    id: '6',
    value: forgotPwdStrings.noSequentialDigit,
  },
  {
    id: '7',
    value: forgotPwdStrings.noRepeatingDigit,
  },
  {
    id: '8',
    value: forgotPwdStrings.noSpace,
  },
]
